<template>
  <div class="wrapper" v-loading.fullscreen.lock="loading">
    <div class="fuwaiall">
      <div class="tinymce-editor">
        <editor id="tinymce" v-model="myValue" :init="init"></editor>
      </div>
    </div>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver/theme';
// import 'tinymce/icons/default/icons';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/media'   // 用于视频播放控制-豆包搜出来的 一定要添加
export default {
  name: "Richtext",
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
    // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
    baseUrl: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      // default: 'link image'
      default: 'link image media'//如果想显示一个视频类型的占位符就加上media,不加media传多个视频并回显会有问题，会出现删不掉的情况
    },
    toolbar: {
      type: [String, Array],
      // default: 'undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | file link image  | removeformat'
      default: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | file customVideo removeVideo link image | removeformat'
    },
  },
  // 111
  data() {
    return {
      myValue: this.value,
      init: {
        language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide', // skin路径
        content_css: '/tinymce/skins/content/default/content.css', // 内容样式路径
        height: 500, // 编辑器高度
        //       /* 确保链接文字也是白色（默认链接可能是蓝色） */
        //       a {
        //         color: #ffffff !important;
        //   text-decoration: underline;
        // }
        content_style: `
          body {
            color: white !important; /* 正文文字白色 */
          }
        p, span, div, li { color: white !important; } /* 强制覆盖标签样式 */
        `,
        branding: false, // 是否禁用“Powered by TinyMCE”
        menubar: false, // 顶部菜单栏显示
        plugins: this.plugins,
        toolbar: this.toolbar,
        // 核心配置：禁用目标选项
        link_target_list: false, // 隐藏目标选择框
        link_default_target: '_blank', // 固定新窗口打开
        target_list: false, // 部分版本中使用此配置（兼容旧版）
        file_picker_types: 'file',
        file_picker_callback: (callback, value, meta) => {
          let that = this
          // //文件分类
          var filetype = '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4, .MP4';
          //后端接收上传文件的地址
          //模拟出一个input用于添加本地文件
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', filetype);
          input.click();
          input.onchange = function () {
            var file = this.files[0];
            console.log(file, file.name);
            const formData = new FormData()
            formData.append('file', file)
            that.$http({
              url: "file/upload",
              method: "POST",
              data: formData
            }).then(res => {
              console.log('上传', res)
              // callback(res.data);
              callback(res.data, {text: file.name});
              // 如果不存在push,存在不做处理,上传的文件
              that.loading = false
            }).catch(err => {
              that.loading = false
              console.log('上传失败')
              // this.zhiafter = []
              // this.addForm.problemImgsdd = []
            })
          }
        },
        //此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        //如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          let that = this
          console.log('走了吗', blobInfo)
          const formData = new FormData()
          formData.append('file', blobInfo.blob())
          this.$http({
            url: "file/upload",
            method: "POST",
            data: formData
          }).then(res => {
            console.log('上传', res)
            success(res.data);
            // 如果不存在push,存在不做处理,上传的文件
            that.loading = false
          }).catch(err => {
            that.loading = false
            failure('上传失败：' + err.message);
            console.log('上传失败', this.loading)
            // this.zhiafter = []
            // this.addForm.problemImgsdd = []
          })
        },
        // 初始化时添加自定义按钮
        setup: (editor) => {
          // 自定义视频上传按钮
          editor.ui.registry.addButton('customVideo', {
            text: '',
            icon: 'embed', // 内置图标（可选）
            onAction: () => this.handleVideoUpload(editor)
          })
              // ,editor.ui.registry.addButton('removeVideo', {
              //   text: '删除选中视频',
              //   icon: 'remove',
              //   onAction: () => this.removeSelectedVideo()
              // }),
              // editor.on('click', (e) => {
              //   if (e.target.tagName === 'VIDEO') {
              //     // 阻止事件冒泡，避免编辑器默认行为干扰
              //     e.stopPropagation();
              //
              //     // 创建范围对象并选中视频元素
              //     const range = document.createRange();
              //     range.selectNode(e.target); // 选中整个视频元素（包括标签本身）
              //
              //     // 设置选区时禁用自动折叠
              //     editor.selection.setRng(range, {
              //       // 关键配置：保留选中状态，不自动折叠光标
              //       preserveSelection: true
              //     });
              //
              //     // 强制聚焦编辑器，确保选中状态可见
              //     editor.focus();
              //   }
              // })
        },
        // 禁用媒体插件的自动处理（避免转为其他格式）
        media_alt_source: false,
        media_poster: false,
        // 其他核心配置（强制允许 video 标签）
        // valid_elements: 'video[src|controls|width|height|style|class]; img[*];', // 明确允许 video 所有属性
        // valid_children: '+body[video|img]', // 允许 body 下直接包含 video 标签
        verify_html: false, // 关闭 HTML 校验
        media_live_embeds: false, // 禁用媒体实时嵌入（避免生成占位符）
        // 确保粘贴或插入时不过滤视频标签
        paste_data_images: true,
        extended_valid_elements: 'video[*],source[*]', // 扩展允许的元素
        // 自定义视频插入格式（确保结构正确）-jc视频宽高在下方控制
        media_url_resolver: (data, resolve) => {
          resolve({
            html: `<video src="${data.url}" controls width="100%" height="200"></video>`
          })
        }
      },
      // ************
      richText: true,
      loading: false,

    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit('input', newValue);
    }
  },
  created() {
  },
  // mmm
  mounted() {
    tinymce.init({});
  },
  methods: {
    onClick(e) {
      this.$emit('onClick', e, tinymce);
    },
    // 定义删除选中视频的方法
    removeSelectedVideo() {
      const editor = tinymce.get(tinymce.editors[0].id)
      if (!editor) return

      // 1. 获取当前选区的所有节点（包含深层嵌套）
      const selection = editor.selection.getSel() // 获取原生 Selection 对象
      const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null
      if (!range) {
        this.$message.warning('请先选中一个视频')
        return
      }

      // 2. 从选区中查找最深层的视频元素（优先选中用户点击的视频）
      let targetVideo = null
      // 检查选区包含的所有节点
      const checkNodes = (node) => {
        if (node.tagName === 'VIDEO') {
          targetVideo = node // 找到视频元素
          return true // 终止递归
        }
        // 递归检查子节点（优先深层节点）
        if (node.childNodes && node.childNodes.length > 0) {
          for (let i = 0; i < node.childNodes.length; i++) {
            if (checkNodes(node.childNodes[i])) return true
          }
        }
        return false
      }

      // 从选区的起始容器开始检查
      checkNodes(range.startContainer.parentNode)

      // 3. 若找到视频，执行删除并更新选区
      if (targetVideo) {
        const parent = targetVideo.parentNode
        const nextSibling = parent.nextSibling // 记录下一个节点用于定位光标

        // 删除视频的父容器（或视频本身）
        editor.dom.remove(parent.tagName === 'BODY' ? targetVideo : parent)

        // 4. 重置光标位置，避免选中整个 body
        if (nextSibling) {
          const newRange = document.createRange()
          newRange.setStartBefore(nextSibling)
          newRange.collapse(true)
          selection.removeAllRanges()
          selection.addRange(newRange)
        } else {
          // 若删除的是最后一个元素，光标定位到文末
          editor.selection.select(editor.getBody(), true)
          editor.selection.collapse(false)
        }
        editor.focus()
        return
      }

      // 5. 未找到视频
      this.$message.warning('请先选中一个视频')
    },
    handleVideoUpload(editor) {
      let that = this;
      var input = document.createElement('input');
      var filetype = '.mp4, .MP4';
      input.setAttribute('type', 'file');
      input.setAttribute('accept', filetype);
      // fileInput.accept = 'video/*' // 只允许选择视频
      input.click();
      input.onchange = function () {//使用这种方式可以检测出来 这种监听不行fileInput.addEventListener('change'
        var file = this.files[0];
        console.log(file, file.name);
        const formData = new FormData()
        formData.append('file', file)
        that.loading = true;
        that.$http({
          url: "file/upload",
          method: "POST",
          data: formData
        }).then(res => {
          console.log('上传视频', res)
          // 插入视频标签到编辑器
          editor.insertContent(`
              <video
                src="${res.data}"
                controls="controls"
                width="80%"
                height="400"
                style="display: block !important;max-width: 100%; margin: 10px auto;"
              ></video>
            `)
          // callback(res.data);
          // 如果不存在push,存在不做处理,上传的文件
          that.loading = false
        }).catch(err => {
          that.loading = false
          console.log('上传失败')
          // this.zhiafter = []
          // this.addForm.problemImgsdd = []
        })
      }


    },
  }
};
</script>
<style scoped lang="scss">
/deep/ {
  /* 取消工具栏边框 */
  .tox-toolbar,
  .tox-toolbar__group {
    border: none !important;
    border-bottom: none !important; /* 移除工具栏底部边框 */
    background: transparent !important; /* 可选：工具栏背景透明 */
  }

  /* 取消编辑器主体边框 */
  .tox-editor-container,
  .tox-edit-area {
    border: none !important;
  }

  /* 取消整个编辑器容器的边框（部分版本可能有外层边框） */
  .tox-tinymce {
    border: none !important;
    box-shadow: none !important; /* 移除可能的阴影效果 */
  }

  /* 可选：取消状态栏边框（底部字数统计区域） */
  .tox-statusbar {
    border-top: none !important;
  }

  .tox-toolbar__primary {
    background: rgba(6, 15, 30, 0.7) !important;
  }

  .tox .tox-edit-area__iframe {
    background: rgba(6, 15, 30, 0.5) !important;
  }

  .tox .tox-toolbar-overlord {
    background: transparent !important;
  }

  .tox .tox-tbtn svg {
    fill: #0090FF !important;
  }

  .tox-statusbar {
    display: none !important;
  }

  .el-upload-list__item.is-ready, .el-upload-list__item.is-uploading {
    display: none !important;
  }

  .el-upload-list__item {
    transition: none;
  }
}
</style>
